import React from "react";

const Plus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-4 -4 40 40" width="40" height="40" className="plus">
    <filter id="dropshadow">
      <feGaussianBlur in="SourceAlpha" stdDeviation="2"></feGaussianBlur>
      <feOffset dx="0" dy="0" result="offsetblur"></feOffset>
      <feComponentTransfer>
        <feFuncA slope="0.8" type="linear"></feFuncA>
      </feComponentTransfer>
      <feMerge>
        <feMergeNode></feMergeNode>
        <feMergeNode in="SourceGraphic"></feMergeNode>
      </feMerge>
    </filter>
    <g filter="url(#dropshadow)">
      <path
        id="Path_1028"
        fill="#0099FF"
        d="M16,1c8.284,0,15,6.716,15,15s-6.716,15-15,15S1,24.284,1,16S7.716,1,16,1z"
      />
      <path
        id="Path_1027"
        fill="#FFFFFF"
        d="M23.201,14.763h-5.966V8.797c0-0.682-0.553-1.236-1.236-1.236h0l0,0
        c-0.682,0-1.236,0.553-1.236,1.236l0,0v5.966H8.797c-0.682,0-1.236,0.553-1.236,1.236l0,0l0,0c0,0.682,0.553,1.236,1.236,1.236
        c0,0,0,0,0,0h5.966v5.966c0,0.682,0.553,1.236,1.236,1.236h0l0,0c0.682,0,1.236-0.553,1.236-1.236l0,0v-5.966h5.966
        c0.682,0,1.236-0.553,1.236-1.236l0,0l0,0C24.437,15.317,23.883,14.763,23.201,14.763z"
      />
    </g>
  </svg>
);

export default Plus;
